module.exports = __webpack_public_path__ + "static/media/scan.a5888082.png";